import { Component, OnInit, Input, Output, EventEmitter  } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
//import { emailValidator } from '../../utils/app-validators';

@Component({
    selector: 'app-top-info-content',
    templateUrl: './top-info-content.component.html',
    styleUrls: ['./top-info-content.component.scss'],
    standalone: false
})
export class TopInfoContentComponent implements OnInit {
  @Input('showInfoContent') showInfoContent:boolean = false;
  @Output() onCloseInfoContent: EventEmitter<any> = new EventEmitter();
  
  constructor(public formBuilder: UntypedFormBuilder) { }

  ngOnInit() {
   
  }
 

  public closeInfoContent(event){
    this.onCloseInfoContent.emit(event);
  }

}
